import React from 'react';
import { Outlet } from '@tanstack/react-router';
import { connect } from 'react-redux';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { withInject, errorBoundary } from '@piwikpro/platform';
import {
  Root, DataRetentionBanner, JWTProvider,
} from '@piwikpro/ui-components';
import { Notifications } from '@piwikpro/notification-crate';
import { Session } from '@piwikpro/auth-crate/Session';

interface Props {
  jwt: SessionState['jwt']
  ProductBar: typeof React.Component
  notifications: Notifications
  sessionService: Session
}

export const Info = ({
  jwt,
  ProductBar,
  notifications,
  sessionService,
}: Props) => (
  <JWTProvider jwt={jwt!} refreshJWT={sessionService.refreshJWT}>
    <Root title={null} withThemes>
      <Root.TopSection>
        <ProductBar />
        <DataRetentionBanner
          onContactFormSubmitSuccess={({ message }) => {
            notifications.push({
              text: message,
              type: 'success',
              autoCloseSeconds: 5,
            });
          }}
          onContactFormSubmitFail={({ message }) => {
            notifications.push({
              text: message,
              type: 'error',
              autoCloseSeconds: 5,
            });
          }}
        />
      </Root.TopSection>
      <Root.Content>
        <Outlet />
      </Root.Content>
    </Root>
  </JWTProvider>
);

const mapStateToProps = (state: { session: SessionState }) => ({
  jwt: state.session.jwt,
});

export default withInject({
  ProductBar: 'AuthCrate.components.ProductBar',
  notifications: 'NotificationCrate.notifications',
  sessionService: 'AuthCrate.session',
})(
  connect(mapStateToProps, null)(
    errorBoundary(Info),
  ),
);
